export const DefaultPalettColors = {
  invoice: {
    green: "#00ff00",
    orange: "#ff8000",
    yellow: "#fff200",
    red: "red",
  },
};
